import { ReferenceField, TextField, useRecordContext } from "react-admin";
import { React } from "react";
import Tooltip from "@mui/material/Tooltip";

/** @param {{ source: string; reference: string; label?: string; sortable?: boolean }} props */
const AliasOrBarcodeReference = ({
  source,
  reference,
  label,
  sortable = undefined,
}) => {
  return (
    <ReferenceField
      source={source}
      reference={reference}
      link="show"
      empty={"\u00A0"}
    >
      <CustomDisplayAliasOrBarcode />
    </ReferenceField>
  );
};

const CustomDisplayAliasOrBarcode = () => {
  const record = useRecordContext();

  return record.alias === "" ? (
    <TextField source="barcode" />
  ) : (
    <Tooltip
      title={
        <p
          style={{
            fontSize: "1.8em",
          }}
        >
          Barcode: {record.barcode}
        </p>
      }
    >
      {/* I had to add this div to make tooltip working
        known issue: https://github.com/marmelab/react-admin/issues/4349 */}
      <div style={{ display: "inline-block" }}>
        <TextField source="alias" />
      </div>
    </Tooltip>
  );
};

export { AliasOrBarcodeReference };
